import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { BusinessRulesInterface } from '../../../../interfaces/business-rules.interface';
import { BusinessRulesTypeEnum } from '../../../../enums/businessRulesTypes.enum';
import { MatDialog, MatSelectChange } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { RemoveRuleDialogComponent } from '../../remove-rule-dialog/remove-rule-dialog.component';
import { ToastsManager } from 'ng2-toastr';
import { BusinessRulesService } from '../../../../services/business-rules.service';
import { AuthService } from '../../../../services/auth.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-business-rules-block-offer',
  templateUrl: './business-rules-blockOffer.html',
  styleUrls: ['./business-rules-blockOffer.scss']
})
export class BusinessRulesBlockOfferComponent implements OnChanges, OnInit {
  @Output()
  businessRuleChange = new EventEmitter<BusinessRulesInterface[]>();
  @Output()
  isActivated = new EventEmitter<string>();

  @Input('businessRules')
  set rules(value: BusinessRulesInterface[]) {
    if (!value) {
      this._rules = [];
      return;
    }
    this._rules = value.filter(rule => rule.type === BusinessRulesTypeEnum.BLOCK_OFFER_WITH_NOT_CONFIGURED_PRODUCTS);
    this.businessRuleChange.emit(this._rules);
  }

  get rules(): BusinessRulesInterface[] {
    return this._rules;
  }

  private _rules: BusinessRulesInterface[];
  public activeRule = [];
  public inActiveRule = [];
  public selectedRule: BusinessRulesInterface;
  public blockOfferForm: FormGroup;
  public selectedOption = 'new';
  public productCategory: string[] = [
    'internet',
    'tv',
    'hardware',
    'premium',
    'telephone',
    'mobileInternet',
    'housingCommunity',
    'extra'
  ];
  public featureToggles: any;
  isSubmitting = false;

  constructor(
    private toastr: ToastsManager,
    private businessRuleService: BusinessRulesService,
    private authService: AuthService,
    private dialog: MatDialog,
    public translate: TranslateService
  ) {
    this.blockOfferForm = new FormGroup({
      label: new FormControl('', [Validators.required]),
      offerType: new FormControl('', [Validators.required]),
      productsCategories: new FormControl('', [Validators.required]),
      isActive: new FormControl(false)
    });
  }

  ngOnInit() {
    this.featureToggles = this.authService.featureTogglesFlags;
  }

  ngOnChanges() {
    this.activeRule = this._rules.filter(rule => rule.isActive === true);
    this.inActiveRule = this._rules.filter(rule => rule.isActive === false);
  }

  onRuleChange(event: MatSelectChange): void {
    const rule = event.value;
    if (rule && rule !== 'new') {
      this.selectedRule = rule;
      this.blockOfferForm.patchValue({
        ...rule.configuredProducts,
        isActive: rule.isActive
      });
    } else {
      this.selectedRule = null;
      this.blockOfferForm.reset({
        isActive: false
      });
    }
  }

  saveRule(formData: FormGroup) {
    if (!this.selectedRule) {
      const { isActive, ...configuredProducts } = formData.getRawValue();
      const rule = {
        configuredProducts,
        isActive,
        type: BusinessRulesTypeEnum.BLOCK_OFFER_WITH_NOT_CONFIGURED_PRODUCTS
      };

      this.isSubmitting = true;

      this.businessRuleService.create(rule).subscribe(
        createdRule => {
          this.selectedRule = createdRule;
          this.rules.push(createdRule);
          this.isActivated.emit();
          this.isSubmitting = false;
          return this.toastr.success(this.translate.instant('BUSINESS_RULES_BLOCK_OFFER.COMPONENT.RULE_SAVED'));
        },
        () => {
          this.isSubmitting = false;
          this.toastr.error(this.translate.instant('BUSINESS_RULES_BLOCK_OFFER.COMPONENT.RULE_SAVE_ERROR'));
        }
      );
      return;
    }
    this.updateRule(formData);
  }

  updateRule(formData: FormGroup): void {
    const { isActive, ...configuredProducts } = formData.getRawValue();
    const businessRuleToBeUpdated = {
      configuredProducts,
      isActive,
      type: BusinessRulesTypeEnum.BLOCK_OFFER_WITH_NOT_CONFIGURED_PRODUCTS
    };

    this.isSubmitting = true;

    this.businessRuleService.update(businessRuleToBeUpdated, this.selectedRule._id).subscribe(
      businessRule => {
        this.selectedRule = businessRule;
        this.isActivated.emit();
        this.isSubmitting = false;
        return this.toastr.success(this.translate.instant('BUSINESS_RULES_BLOCK_OFFER.COMPONENT.RULE_UPDATED'));
      },
      () => {
        this.isSubmitting = false;
        this.toastr.error(this.translate.instant('BUSINESS_RULES_BLOCK_OFFER.COMPONENT.RULE_UPDATE_ERROR'));
      }
    );
  }

  deleteRuleModal() {
    this.dialog
      .open(RemoveRuleDialogComponent, { disableClose: true })
      .afterClosed()
      .subscribe(res => {
        if (res) {
          this.deleteRule();
        }
      });
  }

  deleteRule(): void {
    this.isSubmitting = true;

    this.businessRuleService.delete(this.selectedRule._id).subscribe(
      () => {
        this._rules = this._rules.filter(rule => rule._id !== this.selectedRule._id);
        this.isActivated.emit();
        this.toastr.info(this.translate.instant('BUSINESS_RULES_BLOCK_OFFER.COMPONENT.RULE_DELETED'));
        this.blockOfferForm.reset({
          isActive: false
        });
        this.selectedOption = 'new';
        this.selectedRule = null;
        this.isSubmitting = false;
      },
      () => {
        this.isSubmitting = false;
        this.toastr.error(this.translate.instant('BUSINESS_RULES_BLOCK_OFFER.COMPONENT.RULE_DELETE_ERROR'));
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/business-rules/business-rules-components/business-rules-blockOffer/business-rules-blockOffer.ts